module.exports = __webpack_public_path__ + "img/logo.ca7f074d.png";